export const firebaseConfig = {
	apiKey: "AIzaSyDBLH_3GNc9OYULQDuy363rFEyuChu-XRM",
	authDomain: "react-noteapp-6e764.firebaseapp.com",
	projectId: "react-noteapp-6e764",
	storageBucket: "react-noteapp-6e764.appspot.com",
	messagingSenderId: "943544356465",
	appId: "1:943544356465:web:7f579c3bf7d3ecedd355d0",
};
